export default {
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
